function init() {
    const nav = document.getElementById('site-nav');

    if (!nav) return;

    const isHome = document.body.classList.contains('home');

    // --- Stan przewijania: przezroczysty na górze home, "solid" po scrollu / na podstronach ---
    const applyScroll = () => {
        if (!isHome || window.scrollY > 50) {
            nav.classList.add('is-scrolled');
        } else {
            nav.classList.remove('is-scrolled');
        }
    };

    applyScroll();
    window.addEventListener('scroll', applyScroll, { passive: true });

    // --- Menu mobilne ---
    const mobileToggle = nav.querySelector('[data-mobile-toggle]');
    const mobileMenu = nav.querySelector('[data-mobile-menu]');
    const iconMenu = nav.querySelector('[data-icon-menu]');
    const iconClose = nav.querySelector('[data-icon-close]');

    if (mobileToggle && mobileMenu) {
        mobileToggle.addEventListener('click', () => {
            const isOpen = mobileMenu.classList.toggle('hidden') === false;

            if (iconMenu) iconMenu.classList.toggle('hidden', isOpen);
            if (iconClose) iconClose.classList.toggle('hidden', !isOpen);
        });
    }

    // --- Dropdown desktop (hover + klik) ---
    nav.querySelectorAll('[data-dropdown]').forEach((dd) => {
        const toggle = dd.querySelector('[data-dropdown-toggle]');
        const menu = dd.querySelector('[data-dropdown-menu]');
        const chevron = dd.querySelector('[data-chevron]');

        if (!toggle || !menu) return;

        const open = () => {
            menu.classList.remove('hidden');
            if (chevron) chevron.classList.add('rotate-180');
        };
        const close = () => {
            menu.classList.add('hidden');
            if (chevron) chevron.classList.remove('rotate-180');
        };

        dd.addEventListener('mouseenter', open);
        dd.addEventListener('mouseleave', close);
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            menu.classList.contains('hidden') ? open() : close();
        });
    });

    // --- Dropdown mobilny ---
    nav.querySelectorAll('[data-mobile-dropdown-toggle]').forEach((toggle) => {
        const menu = toggle.parentElement.querySelector('[data-mobile-dropdown-menu]');
        const chevron = toggle.querySelector('[data-mobile-chevron]');

        if (!menu) return;

        toggle.addEventListener('click', () => {
            const nowHidden = menu.classList.toggle('hidden');

            menu.classList.toggle('flex', !nowHidden);
            if (chevron) chevron.classList.toggle('rotate-180', !nowHidden);
        });
    });
}

export default {init};
